import { render } from "./ui-button-delete.vue?vue&type=template&id=069f7c45&ts=true"
import script from "./ui-button-delete.vue?vue&type=script&lang=ts"
export * from "./ui-button-delete.vue?vue&type=script&lang=ts"

import "./ui-button-delete.vue?vue&type=style&index=0&id=069f7c45&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__